import { styled } from "../../../stitches.config"

export const Separator = styled("hr", {
  length: 0,
  borderColor: "$slate6",
  borderWidth: 2,
  margin: "$8 0",
  width: 24,
})
